import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getCards, getCategories, importCards, setCardCategoryItem, setCardKey } from '../../actions';
import ButtonPanel from '../../../QbmPage/ButtonPanel';
import { connect } from 'react-redux'
import classNames from 'classnames';
import moment from 'moment';
import { MODAL_CARD_CATEGORY_DELETE, MODAL_CARD_CATEGORY_FORM, MODAL_CARD_CATEGORY_FRAME, showModal } from '../../../../modules/modals';
import './style.scss';

class Category extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      selected: []
    }
  }

  onSelected = (e) => {
    const {categories, selected, setCardKey, getCards} = this.props;
    let tmp = [...selected];
    const value = e.target.value;
    if(tmp.includes(value)){
      tmp = tmp.filter(id => id != value);
      categories.forEach(cat => {
        if(cat.parent_id == value){
          tmp = tmp.filter(id => id != cat.id);
        }
      });
    } else {
      tmp.push(value)
      categories.forEach(cat => {
        if(cat.parent_id == value){
          tmp.push(cat.id.toString())
        }
      });
    }
    setCardKey('selected', tmp)
    getCards(tmp)
  }

  render() {
    const {formatMessage} = this.context;
    const {categories, category, subject, selected, showModal} = this.props;
    console.log("🚀 ~ file: Category.jsx ~ line 45 ~ Category ~ render ~ selected", selected)
    return (
        <div className="qbm-accordion-component CategoryCard">
          <div className="qbm-accordion-title">
            {formatMessage('titleCardCategory')}
          </div>
          <div className="posr qbm-accordion-body open">
            <div className="qbm-accordion-content">
              {categories.filter(_i => !_i.parent_id).map(item => (
                <React.Fragment>
                  <div
                    key={`category-item-${item.id}`}
                    className={classNames("qbm-accordion-content__item ", {'qbm-accordion-content__item--selected': category && category.id == item.id ? true : false})}
                    onClick={() => {
                      this.props.setCardCategoryItem(item);
                      // this.props.getRoomStudents(item.id);
                    }}
                  >
                    <div style={{display: 'flex', width: 'calc(100% - 90px)'}}>
                      <input type="checkbox" 
                        id={'cat_' + item.id} 
                        value={item.id} 
                        checked={selected.includes(item.id.toString())}
                        onChange={this.onSelected} 
                      />
                      <label for={"cat_" + item.id}></label>
                      <span className="qbm-accordion-content__item__name text-ellipsis" title={item.name}>{item.name}</span>
                    </div>
                    <div className='action'>
                      <div className='text'>({item.count})</div>
                    <i style={{color: item.published ? '#52c41a' : '#fa541c' }} className="fas fa-code" onClick={() => {
                        showModal({
                          modalType : MODAL_CARD_CATEGORY_FRAME,
                          modalProps : {
                            id: item.id,
                            card: item,
                          }
                        });
                      }}></i>
                      {Boolean(item.published) && <a href={'/cards/view/'+item.token} target="_blank"><i className="fa fa-eye"></i></a>}
                      <a href={'/api/card/export-doc?id='+item.id} target="_blank"><i class="fa fa-download"></i></a>
                    </div>
                  </div>
                  {categories.filter(_i => _i.parent_id == item.id).map(_i => <div
                    key={`categorysub-item-${_i.id}`}
                    className={classNames("qbm-accordion-content__item ", "qbm-accordion-content__item__subitem", {'qbm-accordion-content__item--selected': category && category.id == _i.id ? true : false})}
                    onClick={() => {
                      this.props.setCardCategoryItem(_i);
                      // this.props.getRoomStudents(item.id);
                    }}
                  >
                    <div style={{display: 'flex', width: 'calc(100% - 90px)'}}>
                      <input 
                        type="checkbox" 
                        id={'subcat_' + _i.id} 
                        value={_i.id} 
                        checked={selected.includes(_i.id.toString())} 
                        onChange={this.onSelected} 
                      />
                      <label for={"subcat_" + _i.id}></label>
                      <span className="qbm-accordion-content__item__name text-ellipsis" title={_i.name}>{_i.name}</span>
                    </div>
                    <div className='action'>
                      <div className='text'>({_i.count})</div>
                      <i className="fas fa-code" style={{color: _i.published ? '#52c41a' : '#fa541c' }} onClick={() => {
                        showModal({
                          modalType : MODAL_CARD_CATEGORY_FRAME,
                          modalProps : {
                            id: _i.id,
                            card: _i,
                          }
                        });
                      }}></i>
                      {Boolean(_i.published) && <a href={'/cards/view/'+_i.token} target="_blank"><i className="fa fa-eye"></i></a>}
                      <a href={'/api/card/export-doc?id='+_i.id} target="_blank"><i class="fa fa-download"></i></a>
                    </div>
                  </div>)}
                </React.Fragment>
              ))}
            </div>
            <ButtonPanel
              handleAddCreateClick = {() => {
                if(!subject){
                  return;
                }
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_CARD_CATEGORY_FORM,
                  modalProps : {
                    initialValues: {
                      subject_id: subject.id
                    }
                  }
                });
              }}
              handleDeleteClick = {() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_CARD_CATEGORY_DELETE,
                  modalProps : {
                    category_id: category.id
                  }
                });
              }}
              handleUpdateClick = {() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_CARD_CATEGORY_FORM,
                  modalProps : {
                    initialValues: {
                      ...category, 
                    }
                  }
                });
              }}
              isCreateActive = {!!subject}
              isUpdateActive = {!!category}
              isDeleteActive = {!!category}
            />
          </div>
          
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.card.categories,
  category: state.card.category_selcted,
  subject: state.card.subject_selcted,
  selected: state.card.selected,
})

const mapDispatchToProps = {
  getCategories,
  setCardKey,
  getCards,
  showModal,
  setCardCategoryItem,
}


export default connect(mapStateToProps, mapDispatchToProps)(Category)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Card/components/Category/Category.jsx